import { motion } from 'framer-motion'

import { Icons } from '@/components/icons'

interface StatusIconProps {
    status: 'processing' | 'error' | 'success'
}

export const StatusIcon = ({ status }: StatusIconProps): JSX.Element => {
    switch (status) {
        case 'processing':
            return (
                <motion.div
                    className="rounded-full h-16 w-16 bg-primary/10 flex items-center justify-center"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1, rotate: 360 }}
                    transition={{
                        duration: 1.5,
                        repeat: Infinity,
                        ease: 'linear'
                    }}
                >
                    <Icons.Process className="w-8 h-8 text-primary" />
                </motion.div>
            )
        case 'error':
            return (
                <motion.div
                    className="rounded-full h-16 w-16 bg-danger/10 flex items-center justify-center"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 4 }}
                >
                    <Icons.ExclamationTriangle className="w-8 h-8 text-danger" />
                </motion.div>
            )
        case 'success':
            return (
                <motion.div
                    className="rounded-full h-16 w-16 bg-success/10 flex items-center justify-center"
                    initial={{ scale: 0 }}
                    animate={{ scale: 1 }}
                    transition={{ duration: 0.3 }}
                >
                    <Icons.CheckCircle className="w-8 h-8 text-success" />
                </motion.div>
            )
    }
}
